module.exports = __webpack_public_path__ + "img/logOut.83c33328.svg";